import { TreatmentProvider } from 'growth-payments-core/experiment/utils';
import { useCallback } from 'react';
import { isConfigReport, isCustomWidgetReport, isJourneyReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { ErrorBoundary } from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import SampleDatawellVisualization from '../../../../experiments/previewVisualization/components/SampleDatawellVisualization';
import useCommerceCRMRecordReportZeroState from '../../../../experiments/previewVisualization/hooks/useCommerceCRMRecordReportZeroState';
import ErrorBoundaryErrorComponent, { ErrorTypes } from '../../../../monitoring/ErrorBoundaryErrorComponent';
import ConfigReportKPIPreview from './sections/kpi/ConfigReportKPIPreview';
import JourneyReportKPIPreview from './sections/kpi/journey-report-kpis/JourneyReportKPIPreview';
import RelationalReportKPIPreview from './sections/kpi/relational-report-kpis/RelationalReportKPIPreview';
import { hasCustomWidgetKpis } from './sections/kpi/sales-custom-widget-kpis/SalesCustomWidgetKPIContent';
import SalesCustomWidgetKPIPreview from './sections/kpi/sales-custom-widget-kpis/SalesCustomWidgetKPIPreview';
import { jsx as _jsx } from "react/jsx-runtime";
const DatawellInsightPreview = ({
  report
}) => {
  const {
    shouldShowZeroState: shouldShowCommerceReportZeroState
  } = useCommerceCRMRecordReportZeroState(report);
  const ErrorComponent = useCallback(() => /*#__PURE__*/_jsx(ErrorBoundaryErrorComponent, {
    type: ErrorTypes.SUMMARY_PREVIEW,
    compact: true,
    "data-test-id": "datawell-insight-preview-error"
  }), []);
  if (shouldShowCommerceReportZeroState) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      report: report,
      ErrorComponent: ErrorComponent,
      children: /*#__PURE__*/_jsx(SampleDatawellVisualization, {
        report: report,
        preview: true
      })
    });
  }
  if (isConfigReport(report)) {
    if (isCustomWidgetReport(report)) {
      return hasCustomWidgetKpis(report) ? /*#__PURE__*/_jsx(ErrorBoundary, {
        report: report,
        ErrorComponent: ErrorComponent,
        children: /*#__PURE__*/_jsx(SalesCustomWidgetKPIPreview, {
          report: report,
          NoSummaryComponent: ErrorComponent
        })
      }) : /*#__PURE__*/_jsx(ErrorComponent, {});
    }
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      report: report,
      ErrorComponent: ErrorComponent,
      children: /*#__PURE__*/_jsx(ConfigReportKPIPreview, {
        report: report,
        NoSummaryComponent: ErrorComponent
      })
    });
  }
  if (isRelationalReport(report)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      report: report,
      ErrorComponent: ErrorComponent,
      children: /*#__PURE__*/_jsx(RelationalReportKPIPreview, {
        report: report,
        NoSummaryComponent: ErrorComponent
      })
    });
  }
  if (isJourneyReport(report)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      report: report,
      ErrorComponent: ErrorComponent,
      children: /*#__PURE__*/_jsx(JourneyReportKPIPreview, {
        report: report
      })
    });
  }
  return /*#__PURE__*/_jsx(ErrorComponent, {});
};
const DatawellInsightPreviewWithTreatmentProvider = ({
  report
}) => {
  return /*#__PURE__*/_jsx(TreatmentProvider, {
    children: /*#__PURE__*/_jsx(DatawellInsightPreview, {
      report: report
    })
  });
};
export default DatawellInsightPreviewWithTreatmentProvider;